import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VaultUserFormOrigin } from '@app/shared/services/tree-structure.service';
import { environment } from '@env/environment';
//
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import { resolve } from 'dns';
import { url } from 'inspector';
import { Subscription } from 'rxjs';
import { data } from 'vis-network';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'report-tag',
  templateUrl: './report-tag.component.html',
  styleUrls: ['./report-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTagComponent implements OnInit, OnDestroy {
  @Output() onResetGraphClickedEvent = new EventEmitter<any>();
  @Input() report;
  @Input() isLoading = true;
  private primesWorker: Worker;
  private startExecutionWorker: Worker;
  isReportExecutionStart = false;
  constructor(private detectChange: ChangeDetectorRef, private router: Router) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.primesWorker?.terminate();

    this.startExecutionWorker?.terminate();
    // this.workers.forEach((w) => w.terminate());
  }
  @Input() isUpdate = false;
  @Input() period_time = 'this_year';
  @Input() isUdpatedDate;
  subscription = new Subscription();
  ngOnInit(): void {}
  async getStatus(id) {
    this.isUpdate = false;
    let data = {
      token: '',
      url: '',
    };

    await new Promise(async (resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists before creating new one
        if (this.primesWorker) {
          this.primesWorker.terminate();
        }

        this.primesWorker = new Worker(new URL('./check-report-status.worker', import.meta.url), { type: 'classic' });
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/report/report-execution-status-updated-date/${id}`;

        this.primesWorker.onmessage = ({ data }) => {
          this.isLoading = false;
          resolve(data);
          if (data.data.status == 'start' || data.data.status == 'inprogress') {
            if (this.router.url == '/reports' || this.router.url == 'reports' || this.router.url.includes('home')) {
              setTimeout(() => {
                this.getStatus(id);
              }, 15000);
            }
          } else {
            if (this.isReportExecutionStart) {
              this.isReportExecutionStart = false;
              this.onResetGraphClickedEvent.emit('done');
            }

            this.period_time = data.data.period;
            this.isUpdate = true;
            this.isUdpatedDate = new Date(data.data.updated_at);
            this.detectChange.detectChanges();
          }
        };
        this.detectChange.detectChanges();
        this.primesWorker.postMessage(data);
      } else {
        // browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }
  async startReportExecution(id) {
    this.isReportExecutionStart = true;
    this.onResetGraphClickedEvent.emit('updating');
    this.isUpdate = false;
    this.isUdpatedDate;

    let data = {
      token: '',
      url: '',
      period: this.period_time,
      report_id: id,
    };
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.startExecutionWorker) {
          this.startExecutionWorker.terminate();
        }

        this.startExecutionWorker = new Worker(new URL('./start-report-execution.worker.ts', import.meta.url), { type: 'classic' });

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/report/report-execution`;

        this.startExecutionWorker.onmessage = ({ data }) => {
          // Terminate worker after completion
          if (this.startExecutionWorker) {
            this.startExecutionWorker.terminate();
            this.startExecutionWorker = undefined;
          }

          resolve(data);
          this.getStatus(this.report.id);
        };
        this.startExecutionWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }
  generateDataKeyPairCreatForm(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }
}
